import { Button, Dialog } from "@rio-cloud/rio-uikit";
import { useIntl } from "react-intl";

import { CheckupExistsAppointment } from "../../api/fetchScheduling";

interface IDuplicateSchedulingDialogProps {
    show: boolean;
    appointment?: CheckupExistsAppointment | null;
    onClose: () => void;
}

const DuplicateSchedulingDialog = ({ show, appointment, onClose }: IDuplicateSchedulingDialogProps) => {
    const intl = useIntl();
    const t = (id: string, values?: Record<string, any>) =>
        intl.formatMessage({ id: `intl-msg:tas.scheduling.duplicateChassis.${id}` }, values);

    return (
        <Dialog
            show={show}
            bsSize="sm"
            title={t('title')}
            body={
                <div className='text-size-14 margin-0'>
                    <p className='margin-0'>
                        {t('openSchedules', { count: 1 })}
                    </p>
                    {appointment?.protocolNumber ? (
                        <ul className='margin-top-5 margin-bottom-5 padding-left-20 text-ellipsis list-disc'>
                            <li>
                                <span className='text-bold'>
                                    {appointment.protocolNumber}
                                </span>
                            </li>
                        </ul>
                    ) : null}
                    <strong className='display-block margin-top-10'>
                        {t('cannotContinue')}
                    </strong>
                </div>
            }
            footer={
                <div className='display-flex justify-content-end'>
                    <Button onClick={onClose} className='btn btn-primary' bsSize='lg'>
                        {t('ok')}
                    </Button>
                </div>
            }
            onCloseValidation={() => {
                onClose();
                return true;
            }}
            showCloseButton
        />
    );
};

export default DuplicateSchedulingDialog;
